export default __webpack_public_path__ + "static/media/flag-bosnia-and-herzegovina.b6c91be4.svg";